import { exhaustiveArray } from '@portals/shared/common/utils/typeUtils';
import { useSearchParams } from 'react-router-dom';

import { operations } from '@/openapi/schema';

type EventQuery = NonNullable<operations['getEvents']['parameters']['query']>;
type Stage = NonNullable<EventQuery['stage']>[number];
type Classification = NonNullable<EventQuery['classification']>[number];

const VALID_STAGES = exhaustiveArray<Stage>(['UPCOMING', 'LAUNCHED', 'DEPRECATED', 'DECOMMISSIONED']);
const VALID_CLASSIFICATIONS = exhaustiveArray<Classification>(['DOMAIN', 'SYSTEM', 'EXPERIENCE']);

export function useEventFilterParams(): Omit<EventQuery, 'page'> {
  const [searchParams] = useSearchParams();

  const stage = searchParams.getAll('stage').filter((s): s is Stage => VALID_STAGES.includes(s as Stage));

  const classification = searchParams
    .getAll('classification')
    .filter((c): c is Classification => VALID_CLASSIFICATIONS.includes(c as Classification));

  return {
    query: searchParams.get('query') ?? undefined,
    stage,
    classification,
    serviceDomainId: searchParams.getAll('serviceDomainId'),
  };
}
